// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6967":"3394608a","7437":"32a95598"}[chunkId] + ".chunk.css";
};